import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PermissionChecker } from '../../../session'
import { PlaceTypeProvider } from '../../_context/PlaceTypeContext'
import AddNewButton from '../AddNewButton'
import FullPageTemplate from '../../../../components/templates/FullPageTemplate'
import MMainMenu from '../../../menu/mainMenu/M.MainMenu'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import Separator from '../../../../components/helpers/Separator'

const MPlacesListPage = ({ type, permission }) => {
  return (
    <FullPageTemplate>
      <PermissionChecker permission={permission}>
        <PlaceTypeProvider value={type}>
          <FilterHandler tempStorageNamespace={type} initialState={{}}>
            <PageHeader />
            <PageContent />
          </FilterHandler>
          <Separator />
          <MMainMenu active={type} />
          <AddNewButton />
        </PlaceTypeProvider>
      </PermissionChecker>
    </FullPageTemplate>
  )
}

export default MPlacesListPage
